<template>
  <div>
    <!--
  I removed this part:
  :class="{ '/*pointer-events-none*/': showPlay }"
  from the div on line 8 because it blocked the controls of the YT-video, and i can't find out why it was added.
  -->
    <div class="relative contains-iframe contains-youtube">
      <div ref="youtubeTarget"></div>
      <AtomIconPlay
        ref="playButton"
        class="absolute w-[74px] h-[74px] md:w-28 md:h-28 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 pointer text-white"
        :class="{ hidden: !showPlay }"
        @click="playVideo()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { usePlayer, PlayerState } from '@vue-youtube/core'

const props = defineProps({
  url: { type: String, required: false, default: undefined },
  size: { type: String, required: false, default: undefined },
})

const showPlay = ref(true)
const videoId = computed(() => getYoutubeIdFromUrl(props.url) ?? '')
// `as const` keeps the 0/1 literals narrow enough for the player's own option types.
const playerVars = {
  autoplay: 0,
  loop: 0,
  rel: 0,
  fs: 1,
  showinfo: 0,
  autohide: 0,
  controls: 1,
  modestbranding: 1,
} as const

const youtubeTarget = ref()
const { instance, onStateChange } = usePlayer(videoId, youtubeTarget, { playerVars })

// Toggle the overlay play button in sync with the player's state changes.
onStateChange((event) => {
  if (event.data === PlayerState.PLAYING) {
    showPlay.value = false
  } else if (event.data === PlayerState.PAUSED) {
    showPlay.value = true
  }
})

function playVideo() {
  instance.value?.playVideo()
  showPlay.value = false
}
</script>
